export interface QueryParamsType {
  [key: string]: string | boolean | number | undefined;
}

export const parseQueryParams = (params: QueryParamsType = {}): string => {
  const queryString = Object.keys(params)
    .map((key: string) => `${key}=${params[key]}`)
    .join('&');

  return !!queryString.length ? `?${queryString}` : '';
};
